import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import moment from "moment";
import ClientesCreate from "../../Clientes/Clientes/ClientesCreate";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { ordenarTallas } from "../../../../utils/tallas";
import { elegirFormatoNota, agregarPieNota, domicilioCliente, agregarAvisoPendienteFacturar, rotuloCopia, firmaConfirmacionPedido } from "../../../../utils/formatoNota";
import { abrirPDF } from "../../../../utils/abrirPDF";

// Búsqueda de cliente: nombre, código, dirección y TODOS sus teléfonos. Los teléfonos se
// comparan solo por dígitos (da igual si los capturaron con espacios o guiones).
const CAMPOS_TEL = ["telefono", "celular", "whatsapp", "oficina", "casa", "telefono2", "telefono3", "celular2", "celular3"];
const soloDigitos = (v) => String(v == null ? "" : v).replace(/\D/g, "");
const filtroBase = createFilterOptions({ stringify: (o) => `${o.junta || ""} ${o.codigo || ""}`, limit: 60 });
const filtrarClientes = (opciones, estado) => {
  const q = soloDigitos(estado.inputValue);
  if (q.length >= 4) {
    const porTel = opciones.filter((o) => CAMPOS_TEL.some((k) => soloDigitos(o[k]).includes(q)));
    if (porTel.length) return porTel.slice(0, 60);
  }
  return filtroBase(opciones, estado);
};
const telefonosDe = (o) =>
  CAMPOS_TEL.map((k) => o[k])
    .filter((t) => t && String(t).trim() && String(t).trim() !== "NA" && soloDigitos(t).length >= 7)
    .filter((t, i, arr) => arr.findIndex((x) => soloDigitos(x) === soloDigitos(t)) === i)
    .join(" · ");

// Una nota puede llevar a lo más 3 vendedores (a cada uno se le paga su comisión completa)
const MAX_VENDEDORES = 3;
const FORMAS_PAGO = ["Efectivo", "Tarjeta", "Transferencia", "Cheque", "Crédito"];

function VentaDirecta() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_INVENTARIOS_ADD = `${process.env.REACT_APP_URL_INVENTARIOS}AddStock`;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  let cancela = moment(date).add(60, "days").format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [grupos, setGrupos] = useState([]); // Ticket 14: zonas/grupos para alta rápida
  const [areas, setAreas] = useState([]); // almacenes
  const [selectedArea, setSelectedArea] = useState(""); // almacén de surtido
  // Turno de la última consulta de inventario: si el usuario cambia de artículo o
  // almacén antes de que llegue la respuesta, la respuesta vieja se descarta.
  const reqInvRef = useRef(0);
  const partidasRef = useRef([]); // copia síncrona de partidas (escaneos seguidos)
  const invCacheRef = useRef({}); // inventario por "articulo|almacen" para no consultar en cada escaneo
  const scanRef = useRef(null); // input del escáner: ahí regresa el cursor al agregar

  const [fecha, setFecha] = useState(hoy);
  const [value, setValue] = useState(null); // cliente seleccionado (autocomplete)
  const [selectedVendedores, setSelectedVendedores] = useState([]); // Ticket 17: varios vendedores
  const [observaciones, setObservaciones] = useState("NA");
  const [aplicaIva, setAplicaIva] = useState(false); // IVA 16% sobre el neto (venta − devoluciones)
  const [ivaIncluido, setIvaIncluido] = useState(false); // el precio ya trae IVA: se desglosa en vez de sumarse
  const [aplicaSeguro, setAplicaSeguro] = useState(false); // Seguro de mercancía (opcional)
  const [porcSeguro, setPorcSeguro] = useState(2); // % del seguro, editable (default 2%)
  // Pago con tarjeta: el precio ya incluye IVA (se desglosa) y al final se agrega 3.5%
  const [pagoTarjeta, setPagoTarjeta] = useState(false);
  // Forma de pago de la nota (la usa el Corte Diario). "Tarjeta" va ligada al checkbox de tarjeta.
  const [formaPago, setFormaPago] = useState("");

  // Ticket 14: modal de alta rápida de cliente
  const [modalCliente, setModalCliente] = useState(false);
  const toggleCliente = () => setModalCliente(!modalCliente);

  // Artículo seleccionado y su desglose color x talla
  const [articuloSel, setArticuloSel] = useState(null);
  const [precio, setPrecio] = useState(0);
  const [colores, setColores] = useState([]); // [{_id, name}]
  const [tallas, setTallas] = useState([]); // [{_id, name}]
  // Catálogo completo de colores/tallas: para vender una combinación que no está asignada al
  // artículo ni tiene registro de inventario (se crea en el back y queda en negativo)
  const [catColores, setCatColores] = useState([]);
  const [catTallas, setCatTallas] = useState([]);
  const extrasRef = useRef({ art: "", cols: [], tals: [] }); // agregados a mano al artículo en curso
  const [extraColor, setExtraColor] = useState("");
  const [extraTalla, setExtraTalla] = useState("");
  const [grid, setGrid] = useState([]); // [{colores, colorNombre, tallas, tallaNombre, cantidad}]
  const [scanTexto, setScanTexto] = useState(""); // lectura del escáner QR/código de barras

  // Multi-artículo: artículos ya agregados a la venta
  const [partidas, setPartidas] = useState([]); // [{articulo:{_id,codigo,descripcion}, precio, lineas:[{colores,tallas,colorNombre,tallaNombre,cantidad,idInv}]}]
  useEffect(() => {
    partidasRef.current = partidas;
  }, [partidas]);

  // Devoluciones (líneas negativas): suman a inventario y restan del total
  const [devArticulo, setDevArticulo] = useState(null);
  const [devColor, setDevColor] = useState("");
  const [devTalla, setDevTalla] = useState("");
  const [devCantidad, setDevCantidad] = useState(1);
  const [devPrecio, setDevPrecio] = useState(0);
  const [devNumVenta, setDevNumVenta] = useState("");
  const [devFecha, setDevFecha] = useState(hoy);
  const [devoluciones, setDevoluciones] = useState([]); // [{articulo:{_id,codigo,descripcion}, idColor, colorNombre, idTalla, tallaNombre, cantidad, precio, numVenta, fecha}]

  // Modo de captura por proporción
  const [modalProporcion, setModalProporcion] = useState(false);
  const toggleProporcion = () => setModalProporcion(!modalProporcion);
  const [colorProporcion, setColorProporcion] = useState(""); // color al que se aplica
  const [totalProporcion, setTotalProporcion] = useState(0);
  const [proporciones, setProporciones] = useState([]); // [{tallas, tallaNombre, proporcion}]

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    axios.get(URL_ARTICULOS, { headers }).then((res) => setArticulos(res.data)).catch(console.log);
    axios.get(URL_CLIENTES, { headers }).then((res) => setClientes(res.data)).catch(console.log);
    axios.get(URL_COLABORADORES, { headers }).then((res) => setColaboradores(res.data)).catch(console.log);
    axios.get(URL_EMPRESAS, { headers }).then((res) => setEmpresas(res.data)).catch(console.log);
    axios.get(URL_GRUPOS, { headers }).then((res) => setGrupos(res.data)).catch(console.log);
    axios
      .get(process.env.REACT_APP_URL_COLORES, { headers })
      .then((res) => setCatColores((res.data || []).filter((c) => c.is_active !== "No")))
      .catch(console.log);
    axios
      .get(process.env.REACT_APP_URL_TALLAS, { headers })
      .then((res) => setCatTallas((res.data || []).filter((t) => t.is_active !== "No")))
      .catch(console.log);
    axios
      .get(URL_AREAS, { headers })
      .then((res) => {
        setAreas(res.data);
        // Si solo hay un almacén (además de General), se deja seleccionado
        const utiles = (res.data || []).filter((a) => a._id !== AREAS_GENERAL);
        if (utiles.length === 1) setSelectedArea(utiles[0]._id);
      })
      .catch(console.log);
  }, []); // eslint-disable-line

  // Inventario de UN artículo en UN almacén (respuesta chica e inmediata)
  async function inventarioDe(idArticulo, idArea) {
    if (!idArticulo || !idArea) return [];
    try {
      const r = await axios.get(`${URL_INVENTARIOS}/articuloArea/${idArticulo}/${idArea}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      return r.data || [];
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  // Rejilla = colores x tallas del artículo + cualquier color/talla con registro de inventario
  // en el almacén (aunque esté en 0 o negativo, o no esté asignado al artículo) + los que se
  // agregaron a mano. Fija disponible e idInv y conserva lo ya capturado.
  function armaRejilla(art, inv, prevGrid) {
    const cols = [...(art.colores || [])];
    let tals = [...(art.tallas || [])];
    (inv || []).forEach((r) => {
      if (r.idColor && !cols.some((c) => String(c._id) === r.idColor)) cols.push({ _id: r.idColor, name: r.color });
      if (r.idTalla && !tals.some((t) => String(t._id) === r.idTalla)) tals.push({ _id: r.idTalla, name: r.talla });
    });
    const extras = extrasRef.current.art === String(art._id) ? extrasRef.current : { cols: [], tals: [] };
    extras.cols.forEach((c) => {
      if (!cols.some((x) => String(x._id) === String(c._id))) cols.push(c);
    });
    extras.tals.forEach((t) => {
      if (!tals.some((x) => String(x._id) === String(t._id))) tals.push(t);
    });
    // Tallas siempre de menor a mayor (las del inventario se agregaron al final)
    tals = ordenarTallas(tals);
    const grid = [];
    cols.forEach((c) => {
      tals.forEach((t) => {
        // Si hay varios registros (ubicaciones) se toma el de más piezas: la venta descuenta de uno solo.
        // Se permite vender sin existencia: el registro puede estar en 0 o negativo (o no existir).
        const match = (inv || [])
          .filter((r) => r.idColor === String(c._id) && r.idTalla === String(t._id))
          .sort((a, b) => b.cantidad - a.cantidad)[0];
        const disponible = match ? parseFloat(match.cantidad) || 0 : 0;
        const prev = (prevGrid || []).find(
          (g) => String(g.colores) === String(c._id) && String(g.tallas) === String(t._id)
        );
        grid.push({
          colores: c._id,
          colorNombre: c.name,
          tallas: t._id,
          tallaNombre: t.name,
          cantidad: prev ? parseFloat(prev.cantidad) || 0 : 0,
          idInv: match ? match._id : "",
          disponible,
        });
      });
    });
    return { cols, tals, grid };
  }

  // Trae el inventario del artículo en el almacén y rehace la rejilla
  async function cargaRejilla(art, idArea) {
    const turno = ++reqInvRef.current;
    const inv = await inventarioDe(art._id, idArea);
    if (turno !== reqInvRef.current) return; // ya cambiaron de artículo/almacén
    const r = armaRejilla(art, inv, []);
    setColores(r.cols);
    setTallas(r.tals);
    setGrid((prev) => armaRejilla(art, inv, prev).grid);
  }

  // Al cambiar el almacén se recalcula lo disponible del artículo en curso
  function cambiaArea(idArea) {
    setSelectedArea(idArea);
    invCacheRef.current = {};
    if (articuloSel) cargaRejilla(articuloSel, idArea);
  }

  // Ticket 15: construye la etiqueta de una option de cliente incluyendo la dirección
  const buildOptCliente = (c) => {
    const fl = (c.nombre_comercial || "#")[0].toUpperCase();
    const ext = c.numero_ext && c.numero_ext !== "NA" ? c.numero_ext : "";
    const dir = `${c.calle || ""} ${ext}`.trim();
    return {
      firstLetter: /[0-9]/.test(fl) ? "0-9" : fl,
      ...c,
      junta: dir ? `${c.nombre_comercial} - ${dir}` : `${c.nombre_comercial}`,
    };
  };

  // Vendedor(es) por default para la nota:
  //  1) el agente del cliente, si es un agente real;
  //  2) si el cliente tiene el genérico "Jefe Jefe" (casi todos los importados) o ninguno,
  //     los últimos vendedores usados en esta computadora.
  const KEY_ULTIMOS_VEND = "ventaDirecta_ultimosVendedores";
  const esGenerico = (v) =>
    `${v.nombre || ""} ${v.apellido || ""}`.trim().toLowerCase() === "jefe jefe";
  function vendedoresPorDefault(cli) {
    if (!cli) return [];
    const c = Array.isArray(cli.contacto) ? cli.contacto[0] : cli.contacto;
    const id = c && (c._id || c);
    const agente = id ? colaboradores.find((x) => x._id === String(id)) : null;
    if (agente && !esGenerico(agente)) return [agente];
    let ultimos = [];
    try {
      ultimos = JSON.parse(localStorage.getItem(KEY_ULTIMOS_VEND) || "[]");
    } catch (e) {
      ultimos = [];
    }
    return colaboradores.filter((x) => ultimos.includes(x._id)).slice(0, MAX_VENDEDORES);
  }

  // Ticket 14: guarda un cliente con datos mínimos + defaults y lo selecciona
  // Cliente dado de alta desde el modal (formulario completo de ClientesCreate):
  // se recarga la lista, se selecciona y su vendedor pasa a la venta.
  async function clienteCreado(nuevo) {
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      const lista = await axios.get(URL_CLIENTES, { headers });
      setClientes(lista.data);
      const creado = lista.data.find((c) => c._id === (nuevo && nuevo._id));
      if (creado) {
        setValue(buildOptCliente(creado));
        if (articuloSel) setPrecio(precioPorLista(articuloSel, creado));
      }
      const vends = vendedoresPorDefault(creado || nuevo);
      if (vends.length) setSelectedVendedores(vends);
    } catch (e) {
      console.log(e);
    }
    setModalCliente(false);
  }

  // Al elegir un artículo, despliega sus colores y tallas en una rejilla
  // Precio por default según la lista de precios del cliente (A-J). Fallback a venta/precioA.
  // Precio de la lista del cliente. Muchos artículos tienen la lista del cliente en $0 (p. ej.
  // lista D): con eso la nota salía en $0. Si la lista no tiene precio se usa el de venta o el
  // de la lista A, y se avisa (respaldo = de dónde salió; "" = de la lista del cliente).
  function precioConOrigen(art, cli) {
    if (!art) return { precio: 0, lista: "", respaldo: "" };
    const lista = (cli && cli.listaPrecios) || "A";
    const p = parseFloat(art["precio" + lista]);
    if (p > 0) return { precio: p, lista, respaldo: "" };
    const venta = parseFloat(art.venta);
    if (venta > 0) return { precio: venta, lista, respaldo: "precio de venta" };
    const a = parseFloat(art.precioA);
    if (a > 0) return { precio: a, lista, respaldo: "lista A" };
    return { precio: 0, lista, respaldo: "sin precio" };
  }
  function precioPorLista(art, cli) {
    return precioConOrigen(art, cli).precio;
  }
  // Aviso cuando el artículo no tiene precio en la lista del cliente
  function avisoPrecio(art, cli) {
    const o = precioConOrigen(art, cli);
    if (!o.respaldo) return "";
    return o.respaldo === "sin precio"
      ? `${art.codigo} no tiene precio en ninguna lista: captura el precio`
      : `${art.codigo} no tiene precio en la lista ${o.lista}: se tomó $${o.precio} (${o.respaldo})`;
  }

  function seleccionaArticulo(art) {
    setArticuloSel(art);
    extrasRef.current = { art: art ? String(art._id) : "", cols: [], tals: [] };
    setExtraColor("");
    setExtraTalla("");
    if (!art) {
      reqInvRef.current++;
      setColores([]);
      setTallas([]);
      setGrid([]);
      return;
    }
    setPrecio(precioPorLista(art, value));
    const aviso = avisoPrecio(art, value);
    if (aviso) Swal.fire({ toast: true, position: "top-end", icon: "warning", title: aviso, showConfirmButton: false, timer: 4000 });
    // Se pinta de inmediato y se completa con el inventario cuando llega
    const r = armaRejilla(art, [], []);
    setColores(r.cols);
    setTallas(r.tals);
    setGrid(r.grid);
    cargaRejilla(art, selectedArea);
  }

  // Escáner QR: cada lectura SUMA 1 directo a la venta (sin teclear ni "Agregar").
  // Si el artículo/color/talla ya está en la venta, se acumula en su renglón.
  async function procesarEscaneo(texto) {
    const t = (texto || "").trim();
    setScanTexto("");
    if (!t) return;
    if (!selectedArea) {
      Swal.fire({ icon: "warning", title: "Selecciona el almacén antes de escanear" });
      return;
    }
    // Separador: las etiquetas nuevas usan "$" (misma tecla en teclado US y español) y van en
    // MAYÚSCULAS sin acentos. Las viejas usan "|", que con lector en teclado US llega como
    // "]", "}" o "¦". Se aceptan todos.
    const partes = t.split(/[$|\]}¦]+/);
    const codigo = (partes[0] || "").trim();
    const colorScan = (partes[1] || "").trim();
    const tallaScan = (partes[2] || "").trim();
    const art = articulos.find(
      (a) => (a.codigo || "").trim().toLowerCase() === codigo.toLowerCase()
    );
    if (!art) {
      Swal.fire({
        icon: "warning",
        title: "Artículo no encontrado",
        text: `Código: ${codigo}`,
        footer: `Se leyó: ${t}`,
      });
      return;
    }
    // Inventario del artículo en el almacén (se guarda para los siguientes escaneos)
    const clave = `${art._id}|${selectedArea}`;
    let inv = invCacheRef.current[clave];
    if (!inv) {
      inv = await inventarioDe(art._id, selectedArea);
      invCacheRef.current[clave] = inv;
    }
    // Sin acentos y sin mayúsculas: la etiqueta nueva trae "CAFE", el catálogo "Café"
    const norm = (v) =>
      (v || "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    let cell = armaRejilla(art, inv, []).grid.find(
      (g) =>
        (norm(g.colorNombre) === norm(colorScan) || g.colores === colorScan) &&
        (norm(g.tallaNombre) === norm(tallaScan) || g.tallas === tallaScan)
    );
    // Sin inventario ni asignación: se vende igual con el color/talla del catálogo (el back crea
    // el registro y lo deja en negativo)
    if (!cell) {
      const c = catColores.find((x) => norm(x.name) === norm(colorScan) || String(x._id) === colorScan);
      const tl = catTallas.find((x) => norm(x.name) === norm(tallaScan) || String(x._id) === tallaScan);
      if (c && tl) {
        cell = { colores: c._id, colorNombre: c.name, tallas: tl._id, tallaNombre: tl.name, idInv: "", disponible: 0 };
      }
    }
    if (!cell) {
      Swal.fire({
        icon: "warning",
        title: "Color/talla no encontrado",
        text: `${colorScan} / ${tallaScan} en ${art.codigo}: no existe en el catálogo de colores/tallas`,
      });
      return;
    }
    // Lo que ya lleva la venta + lo que esté capturado en la rejilla de ese mismo artículo
    const enRejilla =
      articuloSel && articuloSel._id === art._id
        ? parseFloat((grid.find((g) => g.idInv && g.idInv === cell.idInv) || {}).cantidad) || 0
        : 0;
    // Sin registro de inventario no hay idInv: se cuenta por artículo/color/talla
    const ya = cell.idInv
      ? enVenta(partidasRef.current, cell.idInv) + enRejilla
      : (partidasRef.current || [])
          .filter((p) => p.articulo._id === art._id)
          .reduce(
            (t, p) =>
              t +
              p.lineas
                .filter((l) => String(l.colores) === String(cell.colores) && String(l.tallas) === String(cell.tallas))
                .reduce((x, l) => x + (parseFloat(l.cantidad) || 0), 0),
            0
          );
    // Se permite vender sin existencia (el inventario queda en negativo); solo se avisa
    const sinExistencia = ya + 1 > (cell.disponible || 0);
    const linea = {
      colores: cell.colores,
      tallas: cell.tallas,
      colorNombre: cell.colorNombre,
      tallaNombre: cell.tallaNombre,
      cantidad: 1,
      idInv: cell.idInv,
      disponible: cell.disponible,
    };
    const origen = precioConOrigen(art, value);
    if (!(origen.precio > 0)) {
      Swal.fire({
        icon: "warning",
        title: `${art.codigo} no tiene precio`,
        text: `No tiene precio en la lista ${origen.lista} ni en la lista A. Selecciónalo en "Artículo", captura el precio y agrégalo.`,
      });
      return;
    }
    const nuevas = mezclarPartidas(partidasRef.current, art, origen.precio, [linea]);
    partidasRef.current = nuevas; // escaneos seguidos ven el conteo al día
    setPartidas(nuevas);
    // Prenda de varias piezas: cada pieza trae su etiqueta con el MISMO QR; si escanean las
    // dos piezas de un conjunto se cobrarían 2 conjuntos. Se avisa en cada escaneo.
    const piezasPrenda = Math.max(1, parseInt(art.piezasPrenda, 10) || 1);
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: sinExistencia || piezasPrenda > 1 || origen.respaldo ? "warning" : "success",
      title: `+1 ${art.codigo} ${cell.colorNombre} ${cell.tallaNombre} (lleva ${ya + 1})${
        sinExistencia ? " · sin existencia: inventario en negativo" : ""
      }${piezasPrenda > 1 ? ` · prenda de ${piezasPrenda} piezas: escanea solo UNA etiqueta por prenda` : ""}${
        origen.respaldo ? ` · sin precio en lista ${origen.lista}: se tomó $${origen.precio} (${origen.respaldo})` : ""
      }`,
      showConfirmButton: false,
      timer: sinExistencia || piezasPrenda > 1 || origen.respaldo ? 3500 : 1200,
    });
    setTimeout(() => scanRef.current && scanRef.current.focus(), 0);
  }

  // Edición directa de cantidad por talla. Se permite vender más de lo disponible:
  // el inventario queda en negativo (la casilla se marca en rojo como aviso).
  function cambiaCantidad(idColor, idTalla, valor) {
    setGrid((prev) =>
      prev.map((g) => {
        if (g.colores === idColor && g.tallas === idTalla) {
          const cant = Math.max(0, parseFloat(valor) || 0);
          return { ...g, cantidad: cant };
        }
        return g;
      })
    );
  }

  // Agrega a la captura un color y/o talla del catálogo (para vender sin inventario ni asignación)
  function agregaExtra() {
    if (!articuloSel) return;
    if (!extraColor && !extraTalla) {
      Swal.fire({ icon: "warning", title: "Escoge un color o una talla" });
      return;
    }
    const ex =
      extrasRef.current.art === String(articuloSel._id)
        ? extrasRef.current
        : { art: String(articuloSel._id), cols: [], tals: [] };
    const c = catColores.find((x) => String(x._id) === extraColor);
    const t = catTallas.find((x) => String(x._id) === extraTalla);
    extrasRef.current = {
      art: ex.art,
      cols: c && !ex.cols.some((x) => String(x._id) === String(c._id)) ? [...ex.cols, { _id: c._id, name: c.name }] : ex.cols,
      tals: t && !ex.tals.some((x) => String(x._id) === String(t._id)) ? [...ex.tals, { _id: t._id, name: t.name }] : ex.tals,
    };
    setExtraColor("");
    setExtraTalla("");
    cargaRejilla(articuloSel, selectedArea);
  }

  // Abre el modal de proporción para un color
  function abreProporcion(idColor) {
    setColorProporcion(idColor);
    setTotalProporcion(0);
    setProporciones(
      ordenarTallas(tallas).map((t) => ({ tallas: t._id, tallaNombre: t.name, proporcion: 0 }))
    );
    toggleProporcion();
  }

  function cambiaProporcion(idTalla, valor) {
    setProporciones((prev) =>
      prev.map((p) =>
        p.tallas === idTalla ? { ...p, proporcion: valor } : p
      )
    );
  }

  // Aplica: cantidad por talla = total * proporcion / sumaProporciones
  function aplicaProporcion() {
    let suma = proporciones.reduce(
      (t, p) => t + (parseFloat(p.proporcion) || 0),
      0
    );
    if (suma <= 0 || totalProporcion <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Datos incompletos",
        text: "Captura el total y al menos una proporción.",
      });
      return;
    }
    setGrid((prev) =>
      prev.map((g) => {
        if (g.colores !== colorProporcion) return g;
        let prop = proporciones.find((p) => p.tallas === g.tallas);
        let p = prop ? parseFloat(prop.proporcion) || 0 : 0;
        let cant = Math.round((totalProporcion * p) / suma);
        return { ...g, cantidad: cant };
      })
    );
    toggleProporcion();
  }

  // Líneas (color/talla con cantidad>0) del artículo que se está capturando ahora
  function lineasActuales() {
    return grid
      .filter((g) => parseFloat(g.cantidad) > 0)
      .map((g) => ({
        colores: g.colores,
        tallas: g.tallas,
        colorNombre: g.colorNombre,
        tallaNombre: g.tallaNombre,
        cantidad: parseFloat(g.cantidad),
        idInv: g.idInv,
        disponible: g.disponible || 0,
      }));
  }

  // Piezas que ya lleva la venta de un registro de inventario (mismo artículo/color/talla)
  const enVenta = (lista, idInv) =>
    (lista || []).reduce(
      (t, p) => t + p.lineas.filter((l) => l.idInv && l.idInv === idInv).reduce((s, l) => s + (parseFloat(l.cantidad) || 0), 0),
      0
    );

  // Suma líneas a la venta: si el artículo ya está (mismo precio) se acumula en SU renglón y,
  // dentro, en la misma color/talla; si no, se agrega un renglón nuevo.
  function mezclarPartidas(prev, art, precioArt, lineas, especial = null) {
    const precioN = parseFloat(precioArt) || 0;
    const i = prev.findIndex((p) => p.articulo._id === art._id && (parseFloat(p.precio) || 0) === precioN);
    if (i < 0) {
      return [
        ...prev,
        {
          articulo: { _id: art._id, codigo: art.codigo, descripcion: art.descripcion },
          precio: precioN,
          lineas: lineas.map((l) => ({ ...l })),
          // Precio menor al de lista autorizado con la clave especial
          ...(especial ? { precioLista: especial.precioLista, clavePrecio: especial.clave } : {}),
        },
      ];
    }
    const ls = prev[i].lineas.map((l) => ({ ...l }));
    lineas.forEach((n) => {
      const j = ls.findIndex((l) => String(l.colores) === String(n.colores) && String(l.tallas) === String(n.tallas));
      if (j < 0) ls.push({ ...n });
      else ls[j] = { ...ls[j], cantidad: (parseFloat(ls[j].cantidad) || 0) + (parseFloat(n.cantidad) || 0) };
    });
    return prev.map((p, k) => (k === i ? { ...p, lineas: ls } : p));
  }

  // Todas las partidas de venta = agregadas + la que se está capturando (si tiene cantidades)
  const partidaEnCurso =
    articuloSel && lineasActuales().length
      ? [
          {
            articulo: {
              _id: articuloSel._id,
              codigo: articuloSel.codigo,
              descripcion: articuloSel.descripcion,
            },
            precio: parseFloat(precio) || 0,
            lineas: lineasActuales(),
          },
        ]
      : [];
  const todasPartidas = [...partidas, ...partidaEnCurso];

  const totalPiezas = todasPartidas.reduce(
    (t, p) => t + p.lineas.reduce((s, l) => s + (parseFloat(l.cantidad) || 0), 0),
    0
  );
  const totalVenta = todasPartidas.reduce(
    (t, p) =>
      t +
      p.lineas.reduce((s, l) => s + (parseFloat(l.cantidad) || 0), 0) *
        (parseFloat(p.precio) || 0),
    0
  );
  const totalDevoluciones = devoluciones.reduce(
    (t, d) => t + (parseFloat(d.cantidad) || 0) * (parseFloat(d.precio) || 0),
    0
  );
  // Neto antes de IVA (venta − devoluciones)
  const subTotalNeto = totalVenta - totalDevoluciones;
  const r2 = (n) => parseFloat((Number(n) || 0).toFixed(2));
  // Con tarjeta el precio de lista YA trae IVA: se desglosa (base = neto / 1.16) y no se suma.
  // Sin tarjeta, "Agregar IVA" lo suma encima.
  const FACTOR_IVA = 1.16;
  // "Agregar IVA" con precio que YA incluye IVA: igual que tarjeta, se desglosa y el total no cambia.
  const desglosaIva = pagoTarjeta || (aplicaIva && ivaIncluido);
  const subTotalNota = desglosaIva ? r2(subTotalNeto / FACTOR_IVA) : subTotalNeto;
  const montoIva = desglosaIva
    ? r2(subTotalNeto - subTotalNota)
    : aplicaIva
    ? r2(subTotalNeto * 0.16)
    : 0;
  // Seguro de mercancía: % editable (default 2%) sobre el valor de la mercancía vendida
  const porcSeguroNum = Math.max(0, parseFloat(porcSeguro) || 0);
  const montoSeguro = aplicaSeguro ? r2((totalVenta * porcSeguroNum) / 100) : 0;
  // Cargo por pago con tarjeta: 3.5% del total de la nota, al final
  const PORC_TARJETA = 0.035;
  const totalAntesTarjeta = subTotalNota + montoIva + montoSeguro;
  const montoTarjeta = pagoTarjeta ? r2(totalAntesTarjeta * PORC_TARJETA) : 0;
  // Total: lo que se carga al cliente (suma a su saldo)
  const totalGeneral = r2(totalAntesTarjeta + montoTarjeta);

  // Agrega el artículo en curso (con sus cantidades) a la lista de partidas
  // Pide y valida la clave especial (precio menor al de lista). Devuelve la clave o null.
  async function pedirClavePrecio(precioDado, precioLista) {
    const r = await Swal.fire({
      title: "Precio especial",
      html: `El precio <b>$${precioDado}</b> es menor al de lista del cliente (<b>$${precioLista}</b>).<br/>Captura la clave especial para autorizarlo.`,
      input: "password",
      inputPlaceholder: "Clave especial",
      inputAttributes: { autocomplete: "new-password" },
      showCancelButton: true,
      confirmButtonText: "Autorizar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async (clave) => {
        try {
          await axios.post(
            `${process.env.REACT_APP_URL_CLAVE_PRECIO}/validar`,
            { clave },
            { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
          );
          return clave;
        } catch (e) {
          const d = e.response && e.response.data;
          Swal.showValidationMessage((d && d.message) || "Clave incorrecta");
          return false;
        }
      },
    });
    return r.isConfirmed ? r.value : null;
  }

  function agregarArticulo(claveAutorizada) {
    if (!articuloSel) {
      Swal.fire({ icon: "warning", title: "Selecciona un artículo" });
      return false;
    }
    if (!selectedArea) {
      Swal.fire({ icon: "warning", title: "Selecciona el almacén" });
      return false;
    }
    const ls = lineasActuales();
    if (!ls.length) {
      Swal.fire({ icon: "warning", title: "Captura cantidades" });
      return false;
    }
    // Se permite vender sin existencia (el inventario queda en negativo); solo se avisa
    const excede = ls.find((l) => enVenta(partidasRef.current, l.idInv) + l.cantidad > l.disponible);
    if (excede) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "warning",
        title: `Sin existencia suficiente de ${excede.colorNombre} ${excede.tallaNombre}: el inventario quedará en negativo`,
        showConfirmButton: false,
        timer: 2500,
      });
    }
    // Precio menor al de la lista del cliente: solo con la clave especial
    const precioLista = parseFloat(precioPorLista(articuloSel, value)) || 0;
    const precioDado = parseFloat(precio) || 0;
    if (precioDado <= 0) {
      Swal.fire({ icon: "warning", title: "Captura el precio", text: `${articuloSel.codigo} está en $0.` });
      return false;
    }
    let especial = null;
    if (precioDado < precioLista - 0.001) {
      if (!claveAutorizada) {
        pedirClavePrecio(precioDado, precioLista).then((clave) => {
          if (clave) agregarArticulo(clave);
        });
        return false;
      }
      especial = { precioLista, clave: claveAutorizada };
    }
    const nuevas = mezclarPartidas(partidasRef.current, articuloSel, precio, ls, especial);
    partidasRef.current = nuevas;
    setPartidas(nuevas);
    seleccionaArticulo(null); // limpia el artículo en curso para capturar el siguiente
    setPrecio(0);
    setTimeout(() => scanRef.current && scanRef.current.focus(), 0);
    return true;
  }

  // Enter en la cantidad o el precio = agregar la prenda a la venta (sin botón)
  function enterAgrega(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      agregarArticulo();
    }
  }

  function quitarPartida(idx) {
    setPartidas((prev) => prev.filter((_, i) => i !== idx));
  }

  // Devolución: jala precio, fecha y N° de venta de la ÚLTIMA vez que este cliente compró
  // el artículo (si ya eligieron color y talla, prefiere esa combinación). Se puede editar.
  const reqUltimaRef = useRef(0);
  const devPrecioRef = useRef(null);
  const [devSinUltima, setDevSinUltima] = useState(false); // el cliente nunca compró ese artículo
  async function jalaUltimaCompra(art, idColor, idTalla) {
    if (!art) {
      setDevSinUltima(false);
      return;
    }
    if (!value || !value._id) {
      Swal.fire({ toast: true, position: "top-end", icon: "info", title: "Elige el cliente para jalar su última compra", showConfirmButton: false, timer: 2000 });
      return;
    }
    const turno = ++reqUltimaRef.current;
    try {
      const q = idColor && idTalla ? `?color=${idColor}&talla=${idTalla}` : "";
      const { data } = await axios.get(`${URL_ARTICULOS_SURTIDOS}/ultimaCompra/${value._id}/${art._id}${q}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      if (turno !== reqUltimaRef.current) return; // ya cambiaron de artículo/color/talla
      if (!data) {
        setDevSinUltima(true);
        setDevNumVenta("");
        // Solo se avisa al elegir el artículo (no otra vez al cambiar color/talla)
        if (!idColor && !idTalla) {
          await Swal.fire({
            icon: "info",
            title: "Sin compra anterior",
            html: `<b>${value.nombre_comercial || "Este cliente"}</b> no tiene compras de <b>${art.codigo}</b> en el sistema.<br/><br/>Captura el <b>precio</b> y la <b>fecha</b> de la venta.`,
            confirmButtonText: "Entendido",
          });
          setTimeout(() => devPrecioRef.current && devPrecioRef.current.focus(), 0);
        }
        return;
      }
      setDevSinUltima(false);
      setDevPrecio(data.precio);
      setDevFecha(data.fecha);
      setDevNumVenta(String(data.numVenta || ""));
    } catch (e) {
      console.log(e);
    }
  }

  // Agrega una línea de devolución (artículo/color/talla + venta/fecha manual)
  function agregarDevolucion() {
    if (!devArticulo) {
      Swal.fire({ icon: "warning", title: "Selecciona el artículo devuelto" });
      return;
    }
    if (!devColor || !devTalla) {
      Swal.fire({ icon: "warning", title: "Selecciona color y talla" });
      return;
    }
    const cant = parseFloat(devCantidad);
    if (!cant || cant <= 0) {
      Swal.fire({ icon: "warning", title: "Captura la cantidad devuelta" });
      return;
    }
    if (!devNumVenta && !devSinUltima) {
      Swal.fire({ icon: "warning", title: "Captura el N° de venta" });
      return;
    }
    const color = (devArticulo.colores || []).find((c) => c._id === devColor);
    const talla = (devArticulo.tallas || []).find((t) => t._id === devTalla);
    setDevoluciones((prev) => [
      ...prev,
      {
        articulo: {
          _id: devArticulo._id,
          codigo: devArticulo.codigo,
          descripcion: devArticulo.descripcion,
        },
        idColor: devColor,
        colorNombre: color ? color.name : "",
        idTalla: devTalla,
        tallaNombre: talla ? talla.name : "",
        cantidad: cant,
        precio: parseFloat(devPrecio) || 0,
        numVenta: devNumVenta || "S/N", // sin compra anterior no hay nota que referenciar
        fecha: devFecha,
      },
    ]);
    // Reset de la línea de devolución
    setDevArticulo(null);
    setDevColor("");
    setDevTalla("");
    setDevCantidad(1);
    setDevPrecio(0);
    setDevNumVenta("");
    setDevFecha(hoy);
    setDevSinUltima(false);
  }

  function quitarDevolucion(idx) {
    setDevoluciones((prev) => prev.filter((_, i) => i !== idx));
  }

  // Genera y abre/descarga el PDF de la nota de venta (Ticket: nota automática)
  function generarNotaPDF({
    numero,
    cliente,
    fechaNota,
    vendedores,
    partidasNota,
    devolucionesNota,
    totVenta,
    totDev,
    totNeto,
    totPzs,
    subTotal,
    iva,
    seguro,
    tarjeta,
    ivaIncluidoNota = false,
    formato = "cambios", // "cambios" | "pagare"
  }) {
    try {
      const doc = new jsPDF();
      // Se imprimen 2 hojas: 1) ORIGINAL para el cliente (con su formato: cambios o pagaré);
      // 2) COPIA = pedido pendiente de facturar hasta que el cliente lo confirme (sin pagaré).
      const COPIAS = 2;
      for (let copia = 1; copia <= COPIAS; copia++) {
        if (copia > 1) doc.addPage();
        const esCopia = copia > 1;
        rotuloCopia(doc, esCopia);
        // Se presenta como PEDIDO (pendiente de facturar hasta que el cliente lo confirme)
        doc.setFontSize(16);
        doc.text("GAVINI", 14, 16);
        doc.setFont(undefined, "bold");
        doc.setFontSize(14);
        doc.text(`PEDIDO${numero ? " No. " + numero : ""}`, 14, 24);
        doc.setFont(undefined, "normal");
        doc.setFontSize(10);
        doc.text(`Fecha: ${fechaNota || ""}`, 14, 31);
        doc.text(`Cliente: ${cliente ? cliente.nombre_comercial || "" : ""}`, 14, 37);
        if (vendedores) doc.text(`Vendedor(es): ${vendedores}`, 14, 43);

        // Con tarjeta los precios se muestran SIN IVA (el IVA va desglosado abajo)
        const factor = tarjeta || ivaIncluidoNota ? 1 / FACTOR_IVA : 1;
        const body = [];
        // Un renglón por ARTÍCULO (sin desglose de color/talla): se suman las piezas.
        // Si el mismo artículo va a dos precios distintos, sale un renglón por precio.
        const agrupa = (lista, getArt, getPrecio, getCant, getLista = () => 0) => {
          const m = new Map();
          lista.forEach((x) => {
            const art = getArt(x) || {};
            const pr = parseFloat(getPrecio(x)) || 0;
            const k = `${art._id || art.codigo}|${pr}`;
            const g = m.get(k) || { art, pr, cant: 0, lista: parseFloat(getLista(x)) || 0 };
            g.cant += parseFloat(getCant(x)) || 0;
            m.set(k, g);
          });
          return [...m.values()];
        };
        agrupa(
          (partidasNota || []).flatMap((p) => (p.lineas || []).map((l) => ({ p, l }))),
          (x) => x.p.articulo,
          (x) => x.p.precio,
          (x) => x.l.cantidad,
          (x) => x.p.precioLista
        ).forEach(({ art, pr, cant, lista }) => {
          const prN = pr * factor;
          // Precio especial (con clave): "(original) precio dado"
          const precioTxt = lista > pr ? `($${(lista * factor).toFixed(2)}) $${prN.toFixed(2)}` : `$${prN.toFixed(2)}`;
          body.push([art.codigo || "", art.descripcion || "", cant, precioTxt, `$${(cant * prN).toFixed(2)}`]);
        });
        // Devoluciones (después de las ventas), también un renglón por artículo
        agrupa(devolucionesNota || [], (d) => d.articulo, (d) => d.precio, (d) => d.cantidad).forEach(({ art, pr, cant }) => {
          const prN = pr * factor;
          body.push([`${art.codigo || ""} (DEV)`, art.descripcion || "", -cant, `$${prN.toFixed(2)}`, `-$${(cant * prN).toFixed(2)}`]);
        });

        doc.autoTable({
          head: [["Código", "Descripción", "Cant", "Precio", "Importe"]],
          body,
          startY: vendedores ? 48 : 43,
          styles: { fontSize: 8 },
          headStyles: { fillColor: [16, 185, 129] },
        });

        let y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : 60) + 8;
        doc.setFontSize(10);
        doc.text(`Total piezas: ${totPzs}`, 14, y);
        // Con tarjeta o con IVA incluido los renglones van sin IVA: el "Venta" con IVA confundiría
        if (!tarjeta && !ivaIncluidoNota) {
          y += 6;
          doc.text(`Venta: $${(totVenta || 0).toFixed(2)}`, 14, y);
          if (totDev) {
            y += 6;
            doc.text(`Devoluciones: -$${(totDev || 0).toFixed(2)}`, 14, y);
          }
        }
        if (iva) {
          y += 6;
          doc.text(`Subtotal: $${(subTotal || 0).toFixed(2)}`, 14, y);
          y += 6;
          doc.text(`IVA 16%: $${(iva || 0).toFixed(2)}`, 14, y);
        }
        if (seguro) {
          y += 6;
          doc.text(`Seguro de mercancía ${porcSeguroNum}%: $${(seguro || 0).toFixed(2)}`, 14, y);
        }
        if (tarjeta) {
          y += 6;
          doc.text(`Cargo por pago con tarjeta 3.5%: $${(tarjeta || 0).toFixed(2)}`, 14, y);
        }
        y += 6;
        doc.setFontSize(12);
        doc.text(`TOTAL: $${(totNeto || 0).toFixed(2)}`, 14, y);
        // La venta directa nace sin factura: recuadro "Mercancía pendiente de facturar"
        let yAviso = agregarAvisoPendienteFacturar(doc, y + 2, numero, esCopia);
        // Firma de confirmación del pedido (en el original con pagaré ya firma el pagaré)
        if (esCopia || formato !== "pagare") yAviso = firmaConfirmacionPedido(doc, yAviso);
        // Pie según el formato: política de cambios o pagaré (sin devoluciones)
        agregarPieNota(doc, formato, yAviso, {
          numero,
          fecha: fechaNota,
          total: totNeto,
          plazo: cliente ? cliente.plazo : 0,
          cliente: cliente ? cliente.nombre_comercial || "" : "",
          domicilio: domicilioCliente(cliente),
        }, esCopia);
      }

      // Abre la nota en otra pestaña (no la descarga)
      abrirPDF(doc);
    } catch (e) {
      console.log("Error generando nota PDF:", e);
    }
  }

  const saveVenta = async (event) => {
    event.preventDefault();
    if (!value || !value._id) {
      Swal.fire({ icon: "warning", title: "Falta el cliente" });
      return;
    }
    if (selectedVendedores.length > MAX_VENDEDORES) {
      Swal.fire({ icon: "warning", title: `Máximo ${MAX_VENDEDORES} vendedores por nota` });
      return;
    }
    const partidasVenta = todasPartidas; // artículos agregados + el que esté en curso
    if (partidasVenta.length === 0 && devoluciones.length === 0) {
      Swal.fire({ icon: "warning", title: "Captura cantidades o devoluciones" });
      return;
    }
    // Ningún artículo puede ir en $0 (pasaba con artículos sin precio en la lista del cliente)
    const sinPrecio = partidasVenta.filter((p) => !(parseFloat(p.precio) > 0));
    if (sinPrecio.length) {
      Swal.fire({
        icon: "error",
        title: "Hay artículos en $0",
        html: `Quítalos y vuelve a agregarlos con su precio:<br/><b>${sinPrecio
          .map((p) => p.articulo.codigo)
          .join(", ")}</b>`,
      });
      return;
    }
    if (!selectedArea) {
      Swal.fire({ icon: "warning", title: "Selecciona el almacén" });
      return;
    }
    if (!formaPago) {
      Swal.fire({ icon: "warning", title: "Selecciona la forma de pago", text: "Efectivo, Tarjeta, Transferencia, Cheque o Crédito." });
      return;
    }
    // Se puede vender sin existencia: si una línea no tiene registro de inventario, el back lo
    // crea y lo deja en negativo.
    const articuloRef = partidasVenta.length
      ? partidasVenta[0].articulo._id
      : devoluciones[0].articulo._id;
    setValidaBoton(false);
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // Ticket 16: empresa por defecto (primera disponible), ya no se pide al usuario
    const empresaDefault = empresas.length ? empresas[0]._id : "";

    // Se guardan TODOS los vendedores seleccionados en colaboradores (arreglo).
    // Si no hay ninguno, se usa el vendedor genérico por defecto.
    const idColaborador = selectedVendedores.length
      ? selectedVendedores.map((v) => v._id)
      : ["613a9434225bce3df050c220"];
    let obsFinal = observaciones || "NA";
    if (selectedVendedores.length) {
      const nombres = selectedVendedores
        .map((v) => `${v.nombre} ${v.apellido || ""}`.trim())
        .join(", ");
      obsFinal =
        obsFinal === "NA" ? `Vendedores: ${nombres}` : `${obsFinal} | Vendedores: ${nombres}`;
    }
    // Deja constancia de las devoluciones (con N° de venta y fecha) en observaciones
    if (devoluciones.length) {
      const notas = devoluciones
        .map(
          (d) =>
            `DEV ${d.articulo.codigo} ${d.colorNombre}/${d.tallaNombre} x${d.cantidad} $${d.precio} (venta ${d.numVenta} ${d.fecha})`
        )
        .join(" | ");
      obsFinal = obsFinal === "NA" ? notas : `${obsFinal} | ${notas}`;
    }

    try {
      const dataPedido = await axios.post(
        URL_PEDIDOS,
        {
          fecha,
          fechaEstado: fecha,
          fechaCreacion: hoy,
          resurtido: "Si",
          ventaDirecta: "Si",
          empresas: empresaDefault,
          clientes: value._id,
          colaboradores: idColaborador,
          fecha_cancelacion: cancela,
          fecha_confirmacion: hoy,
          total_general: totalGeneral,
          total_piezas: totalPiezas,
          observaciones: obsFinal,
          articulos: articuloRef,
          pedidoCliente: "NA",
          compradores: "613a9434225bce3df050c220",
          surtido: 0,
          pendiente_surtir: totalPiezas,
          confirmacionPedido: "No",
          status: "Abierto",
          fechaEstCodigos: hoy,
          fechaEstFicha: hoy,
          fechaEstAuditoria: hoy,
          fechaEstMuestraFit: hoy,
          fechaEstMuestraConfirmacion: hoy,
          fechaEstEtiquetas: hoy,
          fechaRealCodigos: hoy,
          fechaRealFicha: hoy,
          fechaRealAuditoria: hoy,
          fechaRealMuestraFit: hoy,
          fechaRealMuestraConfirmacion: hoy,
          fechaRealEtiquetas: hoy,
          autorizacionFitFecha: hoy,
          autorizacionCostosFecha: hoy,
          autorizacionDisenoFecha: hoy,
          autorizacionCalidadFecha: hoy,
          autorizacionPloterFecha: hoy,
          autorizacionPloterDisenoFecha: hoy,
          autorizacionSurtirFecha: hoy,
          autorizacionFitColaborador: "613a9434225bce3df050c220",
          autorizacionCostosColaborador: "613a9434225bce3df050c220",
          autorizacionDisenoColaborador: "613a9434225bce3df050c220",
          autorizacionCalidadColaborador: "613a9434225bce3df050c220",
          autorizacionPloterColaborador: "613a9434225bce3df050c220",
          autorizacionPloterDisenoColaborador: "613a9434225bce3df050c220",
          autorizacionSurtirColaborador: "613a9434225bce3df050c220",
          descuento: 0,
          pendFechaConf: hoy,
        },
        { headers }
      );

      const idPedido = dataPedido.data._id;

      // 1) Un ArticulosPedido por cada línea (color/talla) de cada partida.
      //    Guardamos el idArtPed y el artículo para el surtido posterior.
      const lineasSurtir = [];
      for (const p of partidasVenta) {
        for (const l of p.lineas) {
          const dataArtPed = await axios.post(
            URL_ARTICULOS_PEDIDO,
            {
              pedidos: idPedido,
              articulos: p.articulo._id,
              colores: l.colores,
              tallas: l.tallas,
              cantidad: l.cantidad,
              pendienteCortar: l.cantidad,
              cortado: 0,
              surtido: 0,
              pendiente_surtir: l.cantidad,
              cantidad_procesos: l.cantidad,
              precio: p.precio,
              ...(p.clavePrecio ? { clavePrecio: p.clavePrecio } : {}),
              descuento: 0,
              total: parseFloat((l.cantidad * p.precio).toFixed(2)),
              codigoBarras: 0,
              precioEtiqueta: 0,
              resurtido: "Si",
              codigoCliente: "NA",
            },
            { headers }
          );
          lineasSurtir.push({
            idArtPed: dataArtPed.data._id,
            idArticulo: p.articulo._id,
            idInv: l.idInv,
            colores: l.colores,
            tallas: l.tallas,
            cantidad: l.cantidad,
          });
        }
      }

      // ===== SURTIDO: descuenta inventario y carga al cliente el NETO =====
      // 1) Encabezado del surtido (backend carga cliente y actualiza pedido)
      const dataSurtido = await axios.post(
        URL_SURTIDOS,
        {
          fecha,
          pedidos: idPedido,
          observaciones: obsFinal,
          numeroFactura: "No",
          user: user.id,
          clientes: value._id,
          colaboradores: idColaborador,
          areas: selectedArea,
          empresas: empresaDefault,
          articulos: articuloRef,
          total_general: totalGeneral,
          saldo: totalGeneral,
          subTotal: subTotalNota,
          iva: montoIva,
          seguro: montoSeguro,
          porcSeguro: aplicaSeguro ? porcSeguroNum : 0,
          pagoTarjeta: pagoTarjeta ? "Si" : "No",
          ivaIncluido: !pagoTarjeta && aplicaIva && ivaIncluido ? "Si" : "No",
          comisionTarjeta: montoTarjeta,
          formaPago,
          impuestos: 0,
          descuento: 0,
          totalCantidad: totalPiezas,
          precio: 0,
          is_active: "Si",
          facturado: "No",
          // Estructuradas para que al cancelar la nota se puedan revertir
          ...(devoluciones.length
            ? {
                devoluciones: devoluciones.map((d) => ({
                  articulos: d.articulo._id,
                  colores: d.idColor,
                  tallas: d.idTalla,
                  areas: selectedArea,
                  cantidad: parseFloat(d.cantidad) || 0,
                  precio: parseFloat(d.precio) || 0,
                  numVenta: String(d.numVenta || ""),
                  fecha: d.fecha || "",
                })),
              }
            : {}),
        },
        { headers }
      );
      const idSurtido = dataSurtido.data._id;

      // 2) Una línea de ArticulosSurtidos por cada partida (descuenta inventario)
      for (const l of lineasSurtir) {
        await axios.post(
          URL_ARTICULOS_SURTIDOS,
          {
            surtidos: idSurtido,
            inventarios: l.idInv,
            cantidad: l.cantidad,
            articulos: l.idArticulo,
            pedidos: idPedido,
            articulosPedido: l.idArtPed,
            colores: l.colores,
            tallas: l.tallas,
            areas: selectedArea,
            facturado: "No",
          },
          { headers }
        );
      }

      // 3) DEVOLUCIONES: suman a inventario (upsert) en el mismo almacén.
      //    El total ya va neto (ventas − devoluciones) en el surtido/pedido.
      for (const d of devoluciones) {
        await axios.patch(
          URL_INVENTARIOS_ADD,
          {
            articulos: d.articulo._id,
            colores: d.idColor,
            tallas: d.idTalla,
            areas: selectedArea,
            cantidad: d.cantidad,
          },
          { headers }
        );
      }

      // Actualiza fecha de último pedido en el cliente (Ticket 3)
      await axios.patch(`${URL_CLIENTES}/${value._id}`, { ultimoPedido: fecha }, { headers });

      // Recordar los vendedores de esta nota para la siguiente (cliente con agente genérico)
      try {
        localStorage.setItem(KEY_ULTIMOS_VEND, JSON.stringify(selectedVendedores.map((v) => v._id)));
      } catch (e) {
        // sin almacenamiento local: solo no se recuerda
      }

      const detalleLog = partidasVenta.length
        ? partidasVenta.map((p) => p.articulo.codigo).join(", ")
        : devoluciones.map((d) => `DEV ${d.articulo.codigo}`).join(", ");
      axios.post(
        URL_LOGS,
        { tipo: "Venta Directa", detalle: detalleLog, user: user.id },
        { headers }
      );

      // Genera automáticamente el PDF de la nota antes de recargar: primero el formato
      // (con cambios o pagaré). Si cancelan, la venta ya quedó y se reimprime en ListadoVentas.
      const formatoNota = await elegirFormatoNota();
      const vendedoresNota = selectedVendedores.length
        ? selectedVendedores.map((v) => `${v.nombre} ${v.apellido || ""}`.trim()).join(", ")
        : "";
      if (formatoNota) generarNotaPDF({
        formato: formatoNota,
        numero: (dataSurtido.data && dataSurtido.data.idSurtido) || "",
        cliente: value,
        fechaNota: fecha,
        vendedores: vendedoresNota,
        partidasNota: partidasVenta,
        devolucionesNota: devoluciones,
        totVenta: totalVenta,
        totDev: totalDevoluciones,
        totNeto: totalGeneral,
        totPzs: totalPiezas,
        subTotal: subTotalNota,
        iva: montoIva,
        seguro: montoSeguro,
        tarjeta: montoTarjeta,
        ivaIncluidoNota: !pagoTarjeta && aplicaIva && ivaIncluido,
      });

      Swal.fire("Listo", "Venta directa y surtido registrados con éxito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1800);
    } catch (error) {
      const data = error.response && error.response.data;
      const detalle = data ? (typeof data === "string" ? data : data.message || JSON.stringify(data)) : "";
      Swal.fire({
        icon: "error",
        title: "No se pudo guardar la venta",
        text: detalle || "Something went wrong!",
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  // Opciones para el autocomplete de cliente (Ticket 15: incluye dirección)
  const options = clientes.map((c) => buildOptCliente(c));

  return (
    <>
      <Header />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-cash-register" style={{ marginRight: 8, color: "#10b981" }} />
                Venta Directa
              </h3>
              <p className="page-subtitle">
                Selecciona artículo y color, captura por proporción o cantidad por talla
              </p>
            </div>
          </div>

          <Form onSubmit={saveVenta}>
            {/* Datos generales */}
            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-info-circle" />
                <span className="form-section-title">Datos Generales</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={2}>
                    <Label>Fecha</Label>
                    <Input
                      type="date"
                      value={fecha}
                      required
                      disabled
                      // onChange={(e) => setFecha(e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <Label>Cliente</Label>
                    <div style={{ display: "flex", gap: 6, alignItems: "flex-start" }}>
                      <div style={{ flex: 1 }}>
                        <Autocomplete
                          size="small"
                          value={value}
                          onChange={(event, sel) => {
                            setValue(sel);
                            // Reajusta el precio del artículo en curso a la lista del cliente
                            if (articuloSel) setPrecio(precioPorLista(articuloSel, sel));
                            // Vendedor por default (se puede cambiar o agregar más)
                            const vends = vendedoresPorDefault(sel);
                            if (vends.length) setSelectedVendedores(vends);
                          }}
                          options={options.sort(
                            (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                          )}
                          groupBy={(option) => option.firstLetter}
                          getOptionLabel={(option) => option.junta || ""}
                          getOptionSelected={(option, val) =>
                            option && val && option._id === val._id
                          }
                          filterOptions={filtrarClientes}
                          renderOption={(o) => (
                            <div>
                              {o.junta}
                              {telefonosDe(o) ? (
                                <div style={{ fontSize: "0.75rem", color: "#64748b" }}>
                                  <i className="fas fa-phone" style={{ marginRight: 4 }} />
                                  {telefonosDe(o)}
                                </div>
                              ) : undefined}
                            </div>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} label="Nombre, código o teléfono" variant="outlined" />
                          )}
                        />
                      </div>
                      <Button
                        color="primary"
                        type="button"
                        size="sm"
                        title="Nuevo Cliente"
                        onClick={toggleCliente}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <i className="fas fa-user-plus" />
                      </Button>
                    </div>
                  </Col>
                  <Col md={4}>
                    <Label>Vendedores (máximo {MAX_VENDEDORES})</Label>
                    <Autocomplete
                      multiple
                      size="small"
                      value={selectedVendedores}
                      onChange={(event, sel) => {
                        if ((sel || []).length > MAX_VENDEDORES) {
                          Swal.fire({
                            icon: "warning",
                            title: `Máximo ${MAX_VENDEDORES} vendedores por nota`,
                            timer: 1800,
                            showConfirmButton: false,
                          });
                          return;
                        }
                        setSelectedVendedores(sel);
                      }}
                      getOptionDisabled={(o) =>
                        selectedVendedores.length >= MAX_VENDEDORES &&
                        !selectedVendedores.some((v) => v._id === o._id)
                      }
                      options={colaboradores.sort((a, b) =>
                        a.nombre > b.nombre ? 1 : -1
                      )}
                      getOptionLabel={(o) => `${o.nombre} ${o.apellido || ""}`}
                      getOptionSelected={(o, v) => o._id === v._id}
                      renderInput={(params) => (
                        <TextField {...params} label="Selecciona" variant="outlined" />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Observaciones</Label>
                    <Input
                      type="text"
                      value={observaciones}
                      onChange={(e) => setObservaciones(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Label>Almacén (surtir de)</Label>
                    <Input
                      type="select"
                      value={selectedArea}
                      onChange={(e) => cambiaArea(e.target.value)}
                    >
                      <option value="">Selecciona almacén</option>
                      {areas
                        .filter((a) => a._id !== AREAS_GENERAL)
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => (
                          <option key={a._id} value={a._id}>
                            {a.name}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={4}>
                    <Label>Artículo</Label>
                    <Autocomplete
                      size="small"
                      value={articuloSel}
                      onChange={(event, sel) => seleccionaArticulo(sel)}
                      options={articulos.sort((a, b) =>
                        (a.codigo || "") > (b.codigo || "") ? 1 : -1
                      )}
                      getOptionLabel={(option) =>
                        option ? `${option.codigo} ${option.descripcion || ""}` : ""
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Selecciona artículo" variant="outlined" />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Precio</Label>
                    <Input
                      type="number"
                      min="0"
                      value={precio}
                      onChange={(e) => setPrecio(e.target.value)}
                      onKeyDown={enterAgrega}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>
                      <i className="fas fa-qrcode" style={{ marginRight: 6 }} />
                      Escanear etiqueta
                    </Label>
                    <Input
                      type="text"
                      innerRef={scanRef}
                      placeholder="Escanea: se suma solo a la venta"
                      value={scanTexto}
                      onChange={(e) => setScanTexto(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          procesarEscaneo(e.target.value);
                        }
                      }}
                    />
                  </Col>
                </Row>
              </div>
            </div>

            {/* Captura por color y talla */}
            {articuloSel && (
              <div className="form-section">
                <div className="form-section-header">
                  <i className="fas fa-table" />
                  <span className="form-section-title">Captura por Color y Talla</span>
                </div>
                <div className="form-section-body">
                  {colores.length === 0 || tallas.length === 0 ? (
                    <p style={{ color: "#94a3b8" }}>
                      El artículo no tiene {colores.length === 0 ? "colores" : "tallas"} asignados: agrega al menos un
                      color y una talla abajo para venderlo.
                    </p>
                  ) : (
                    colores.map((col) => (
                      <div key={col._id} style={{ marginBottom: 14 }}>
                        <Row className="align-items-end">
                          <Col md={2}>
                            <strong>{col.name}</strong>
                            <br />
                            <Button
                              size="sm"
                              color="primary"
                              type="button"
                              style={{ marginTop: 4 }}
                              onClick={() => abreProporcion(col._id)}
                            >
                              <i className="fas fa-percentage" style={{ marginRight: 4 }} />
                              Proporción
                            </Button>
                          </Col>
                          {grid
                            .filter((g) => g.colores === col._id)
                            .map((g) => (
                              <Col md={1} key={g.tallas}>
                                <Label>{g.tallaNombre}</Label>
                                <Input
                                  bsSize="sm"
                                  type="number"
                                  min="0"
                                  value={g.cantidad}
                                  disabled={!selectedArea}
                                  title={
                                    (parseFloat(g.cantidad) || 0) > (g.disponible || 0)
                                      ? "Sin existencia suficiente: el inventario quedará en negativo"
                                      : undefined
                                  }
                                  style={
                                    (parseFloat(g.cantidad) || 0) > (g.disponible || 0)
                                      ? { borderColor: "#ef4444", background: "#fef2f2" }
                                      : undefined
                                  }
                                  onChange={(e) =>
                                    cambiaCantidad(g.colores, g.tallas, e.target.value)
                                  }
                                  onKeyDown={enterAgrega}
                                />
                                <small
                                  style={{
                                    color: (g.disponible || 0) > 0 ? "#10b981" : "#ef4444",
                                    fontSize: "0.65rem",
                                  }}
                                >
                                  Disp: {g.disponible || 0}
                                </small>
                              </Col>
                            ))}
                        </Row>
                      </div>
                    ))
                  )}
                  <Row className="align-items-end" style={{ marginTop: 6 }}>
                    <Col md={12}>
                      <small style={{ color: "#64748b" }}>
                        ¿Falta un color o talla? Agrégalo para venderlo aunque no haya inventario (quedará en
                        negativo).
                      </small>
                    </Col>
                    <Col md={3}>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={extraColor}
                        onChange={(e) => setExtraColor(e.target.value)}
                      >
                        <option value="">Color...</option>
                        {catColores
                          .filter((c) => !colores.some((x) => String(x._id) === String(c._id)))
                          .sort((a, b) => String(a.name).localeCompare(String(b.name)))
                          .map((c) => (
                            <option key={c._id} value={c._id}>
                              {c.name}
                            </option>
                          ))}
                      </Input>
                    </Col>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={extraTalla}
                        onChange={(e) => setExtraTalla(e.target.value)}
                      >
                        <option value="">Talla...</option>
                        {ordenarTallas(catTallas.filter((t) => !tallas.some((x) => String(x._id) === String(t._id)))).map(
                          (t) => (
                            <option key={t._id} value={t._id}>
                              {t.name}
                            </option>
                          )
                        )}
                      </Input>
                    </Col>
                    <Col md={2}>
                      <Button size="sm" color="secondary" type="button" onClick={agregaExtra} disabled={!selectedArea}>
                        <i className="fas fa-plus" style={{ marginRight: 4 }} />
                        Agregar
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={12}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <h5 style={{ marginTop: 10 }}>
                        Subtotal artículo:{" "}
                        {lineasActuales().reduce((s, l) => s + l.cantidad, 0)} pzas. /{" "}
                        {"$" +
                          new Intl.NumberFormat("en-US").format(
                            lineasActuales().reduce((s, l) => s + l.cantidad, 0) *
                              (parseFloat(precio) || 0)
                          )}
                      </h5>
                      <Button type="button" color="primary" onClick={() => agregarArticulo()}>
                        <i className="fas fa-plus" style={{ marginRight: 6 }} />
                        Agregar artículo a la venta
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            {/* Partidas agregadas a la venta */}
            {partidas.length > 0 && (
              <div className="form-section">
                <div className="form-section-header">
                  <i className="fas fa-list" />
                  <span className="form-section-title">Artículos de la venta</span>
                </div>
                <div className="form-section-body">
                  <table className="table table-sm table-bordered">
                    <thead className="thead-dark">
                      <tr>
                        <th>Artículo</th>
                        <th>Detalle (color/talla x cant)</th>
                        <th>Piezas</th>
                        <th>Precio</th>
                        <th>Importe</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {partidas.map((p, idx) => {
                        const pzas = p.lineas.reduce((s, l) => s + l.cantidad, 0);
                        return (
                          <tr key={idx}>
                            <td>
                              {p.articulo.codigo} {p.articulo.descripcion}
                            </td>
                            <td style={{ fontSize: "0.8rem" }}>
                              {p.lineas
                                .map(
                                  (l) =>
                                    `${l.colorNombre}/${l.tallaNombre} x${l.cantidad}`
                                )
                                .join(", ")}
                            </td>
                            <td>{pzas}</td>
                            <td>
                              {p.precioLista ? (
                                <span title="Precio especial autorizado con clave">
                                  <span style={{ color: "#64748b" }}>(${p.precioLista})</span>{" "}
                                  <b style={{ color: "#b45309" }}>${p.precio}</b>
                                </span>
                              ) : (
                                `$${p.precio}`
                              )}
                            </td>
                            <td>
                              $
                              {new Intl.NumberFormat("en-US").format(pzas * p.precio)}
                            </td>
                            <td>
                              <Button
                                color="danger"
                                size="sm"
                                type="button"
                                onClick={() => quitarPartida(idx)}
                              >
                                <i className="fas fa-trash" />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Devoluciones (negativas): suman a inventario y bajan el total */}
            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-undo" />
                <span className="form-section-title">Devoluciones</span>
              </div>
              <div className="form-section-body">
                <Row className="align-items-end">
                  <Col md={3}>
                    <Label>Artículo devuelto</Label>
                    <Autocomplete
                      size="small"
                      value={devArticulo}
                      onChange={(event, sel) => {
                        setDevArticulo(sel);
                        setDevColor("");
                        setDevTalla("");
                        setDevPrecio(sel ? sel.venta || 0 : 0);
                        jalaUltimaCompra(sel);
                      }}
                      options={articulos.sort((a, b) =>
                        (a.codigo || "") > (b.codigo || "") ? 1 : -1
                      )}
                      getOptionLabel={(option) =>
                        option ? `${option.codigo} ${option.descripcion || ""}` : ""
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Artículo" variant="outlined" />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Color</Label>
                    <Input
                      type="select"
                      value={devColor}
                      onChange={(e) => {
                        setDevColor(e.target.value);
                        jalaUltimaCompra(devArticulo, e.target.value, devTalla);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {(devArticulo ? devArticulo.colores || [] : []).map((c) => (
                        <option key={c._id} value={c._id}>
                          {c.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Label>Talla</Label>
                    <Input
                      type="select"
                      value={devTalla}
                      onChange={(e) => {
                        setDevTalla(e.target.value);
                        jalaUltimaCompra(devArticulo, devColor, e.target.value);
                      }}
                    >
                      <option value="">--</option>
                      {ordenarTallas(devArticulo ? devArticulo.tallas || [] : []).map((t) => (
                        <option key={t._id} value={t._id}>
                          {t.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Label>Cant.</Label>
                    <Input
                      type="number"
                      min="1"
                      value={devCantidad}
                      onChange={(e) => setDevCantidad(e.target.value)}
                    />
                  </Col>
                  <Col md={1}>
                    <Label>Precio</Label>
                    <Input
                      type="number"
                      min="0"
                      innerRef={devPrecioRef}
                      value={devPrecio}
                      onChange={(e) => setDevPrecio(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>N° venta</Label>
                    <Input
                      type="text"
                      value={devNumVenta}
                      onChange={(e) => setDevNumVenta(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Fecha venta</Label>
                    <div style={{ display: "flex", gap: 6 }}>
                      <Input
                        type="date"
                        value={devFecha}
                        onChange={(e) => setDevFecha(e.target.value)}
                      />
                      <Button
                        color="warning"
                        type="button"
                        onClick={agregarDevolucion}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <i className="fas fa-plus" />
                      </Button>
                    </div>
                  </Col>
                </Row>
                {devSinUltima && devArticulo ? (
                  <div style={{ color: "#b45309", fontSize: "0.85rem", marginTop: 6 }}>
                    <i className="fas fa-info-circle" style={{ marginRight: 6 }} />
                    Sin compra anterior de este artículo: captura el precio y la fecha de la venta (el N° de venta es opcional).
                  </div>
                ) : undefined}

                {devoluciones.length > 0 && (
                  <table className="table table-sm table-bordered mt-3">
                    <thead className="thead-dark">
                      <tr>
                        <th>Artículo</th>
                        <th>Color/Talla</th>
                        <th>Cant.</th>
                        <th>Precio</th>
                        <th>Importe</th>
                        <th>N° venta</th>
                        <th>Fecha</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {devoluciones.map((d, idx) => (
                        <tr key={idx}>
                          <td>
                            {d.articulo.codigo} {d.articulo.descripcion}
                          </td>
                          <td>
                            {d.colorNombre}/{d.tallaNombre}
                          </td>
                          <td>{d.cantidad}</td>
                          <td>${d.precio}</td>
                          <td>
                            −$
                            {new Intl.NumberFormat("en-US").format(
                              d.cantidad * d.precio
                            )}
                          </td>
                          <td>{d.numVenta}</td>
                          <td>{d.fecha}</td>
                          <td>
                            <Button
                              color="danger"
                              size="sm"
                              type="button"
                              onClick={() => quitarDevolucion(idx)}
                            >
                              <i className="fas fa-trash" />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>

            {/* Totales generales: venta − devoluciones = neto */}
            <div className="form-section">
              <div className="form-section-body">
                <Row>
                  <Col md={12}>
                    <h5 style={{ margin: 0 }}>
                      Venta: {totalPiezas} pzas. / $
                      {new Intl.NumberFormat("en-US").format(totalVenta)}
                    </h5>
                    {totalDevoluciones > 0 && (
                      <h5 style={{ margin: "6px 0", color: "#dc3545" }}>
                        Devoluciones: −$
                        {new Intl.NumberFormat("en-US").format(totalDevoluciones)}
                      </h5>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        margin: "10px 0",
                      }}
                    >
                      <label
                        htmlFor="selFormaPago"
                        style={{ margin: 0, fontSize: "1rem", fontWeight: 600, textTransform: "none" }}
                      >
                        Forma de pago
                      </label>
                      <Input
                        id="selFormaPago"
                        type="select"
                        bsSize="sm"
                        value={formaPago}
                        invalid={!formaPago}
                        onChange={(e) => {
                          const v = e.target.value;
                          setFormaPago(v);
                          setPagoTarjeta(v === "Tarjeta");
                          if (v === "Tarjeta") setAplicaIva(false);
                        }}
                        style={{ maxWidth: 200 }}
                      >
                        <option value="">Selecciona...</option>
                        {FORMAS_PAGO.map((f) => (
                          <option key={f} value={f}>
                            {f}
                          </option>
                        ))}
                      </Input>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        margin: "10px 0",
                      }}
                    >
                      <input
                        id="chkIva"
                        type="checkbox"
                        checked={aplicaIva && !pagoTarjeta}
                        disabled={pagoTarjeta}
                        onChange={async (e) => {
                          if (!e.target.checked) {
                            setAplicaIva(false);
                            setIvaIncluido(false);
                            return;
                          }
                          // ¿El precio ya trae IVA? Sí = se desglosa (total igual); No = se suma el 16%
                          const r = await Swal.fire({
                            title: "¿El precio ya incluye IVA?",
                            html:
                              "<b>Sí:</b> el total no cambia y el IVA se desglosa (subtotal = precio ÷ 1.16).<br/>" +
                              "<b>No:</b> se suma el 16% al precio.",
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonText: "Sí, ya incluye IVA",
                            cancelButtonText: "No, sumar 16%",
                            cancelButtonColor: "#3085d6",
                          });
                          if (r.isConfirmed) {
                            setIvaIncluido(true);
                            setAplicaIva(true);
                          } else if (r.dismiss === Swal.DismissReason.cancel) {
                            setIvaIncluido(false);
                            setAplicaIva(true);
                          }
                        }}
                        style={{ width: 18, height: 18, margin: 0, cursor: "pointer" }}
                      />
                      <label
                        htmlFor="chkIva"
                        style={{
                          margin: 0,
                          cursor: "pointer",
                          fontSize: "1rem",
                          fontWeight: 500,
                          textTransform: "none",
                        }}
                      >
                        Agregar IVA (16%)
                        {pagoTarjeta
                          ? " — con tarjeta el IVA ya va incluido"
                          : aplicaIva
                          ? ivaIncluido
                            ? " — incluido en el precio (se desglosa)"
                            : " — se suma al precio"
                          : ""}
                      </label>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        margin: "10px 0",
                      }}
                    >
                      <input
                        id="chkTarjeta"
                        type="checkbox"
                        checked={pagoTarjeta}
                        onChange={(e) => {
                          const v = e.target.checked;
                          setPagoTarjeta(v);
                          if (v) setAplicaIva(false);
                          if (v) setFormaPago("Tarjeta");
                          else if (formaPago === "Tarjeta") setFormaPago("");
                        }}
                        style={{ width: 18, height: 18, margin: 0, cursor: "pointer" }}
                      />
                      <label
                        htmlFor="chkTarjeta"
                        style={{
                          margin: 0,
                          cursor: "pointer",
                          fontSize: "1rem",
                          fontWeight: 500,
                          textTransform: "none",
                        }}
                      >
                        Pago con tarjeta (IVA desglosado + 3.5%)
                      </label>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        margin: "10px 0",
                      }}
                    >
                      <input
                        id="chkSeguro"
                        type="checkbox"
                        checked={aplicaSeguro}
                        onChange={(e) => setAplicaSeguro(e.target.checked)}
                        style={{ width: 18, height: 18, margin: 0, cursor: "pointer" }}
                      />
                      <label
                        htmlFor="chkSeguro"
                        style={{
                          margin: 0,
                          cursor: "pointer",
                          fontSize: "1rem",
                          fontWeight: 500,
                          textTransform: "none",
                        }}
                      >
                        Seguro de mercancía
                      </label>
                      <input
                        type="number"
                        min="0"
                        step="0.1"
                        value={porcSeguro}
                        disabled={!aplicaSeguro}
                        onChange={(e) => setPorcSeguro(e.target.value)}
                        style={{ width: 70, marginLeft: 4 }}
                        className="form-control form-control-sm"
                      />
                      <span>%</span>
                    </div>
                    {(aplicaIva || aplicaSeguro || pagoTarjeta) && (
                      <h5 style={{ margin: "6px 0" }}>
                        Subtotal{desglosaIva ? " (sin IVA)" : ""}: $
                        {new Intl.NumberFormat("en-US").format(subTotalNota)}
                      </h5>
                    )}
                    {montoIva > 0 && (
                      <h5 style={{ margin: "6px 0" }}>
                        IVA 16%: $
                        {new Intl.NumberFormat("en-US").format(montoIva)}
                      </h5>
                    )}
                    {aplicaSeguro && (
                      <h5 style={{ margin: "6px 0" }}>
                        Seguro de mercancía {porcSeguroNum}%: $
                        {new Intl.NumberFormat("en-US").format(montoSeguro)}
                      </h5>
                    )}
                    {pagoTarjeta && (
                      <h5 style={{ margin: "6px 0" }}>
                        Cargo por pago con tarjeta 3.5%: $
                        {new Intl.NumberFormat("en-US").format(montoTarjeta)}
                      </h5>
                    )}
                    <h4 style={{ marginTop: 6 }}>
                      TOTAL: $
                      {new Intl.NumberFormat("en-US").format(totalGeneral)}
                    </h4>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="submit-bar">
              <Button href="/MenuVentas" className="btn btn-danger" id="botonListado">
                Regresar
              </Button>
              <Button type="submit" className="btn btn-success" disabled={!validaBoton}>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar Venta
              </Button>
            </div>
          </Form>

          {/* Modal de captura por proporción */}
          <Modal isOpen={modalProporcion} toggle={toggleProporcion}>
            <ModalHeader toggle={toggleProporcion}>
              <i className="fas fa-percentage" style={{ marginRight: 8, color: "#3b82f6" }} />
              Captura por proporción
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={6}>
                  <Label>Total a repartir</Label>
                  <Input
                    type="number"
                    min="0"
                    value={totalProporcion}
                    onChange={(e) => setTotalProporcion(parseFloat(e.target.value) || 0)}
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                {proporciones.map((p) => (
                  <Col md={3} key={p.tallas} style={{ marginBottom: 8 }}>
                    <Label>{p.tallaNombre}</Label>
                    <Input
                      bsSize="sm"
                      type="number"
                      min="0"
                      value={p.proporcion}
                      onChange={(e) => cambiaProporcion(p.tallas, e.target.value)}
                    />
                  </Col>
                ))}
              </Row>
              <p style={{ fontSize: "0.75rem", color: "#64748b", marginTop: 8 }}>
                La cantidad de cada talla = Total × (proporción de la talla ÷ suma de
                proporciones).
              </p>
              <div className="submit-bar">
                <Button color="secondary" type="button" onClick={toggleProporcion}>
                  Cancelar
                </Button>
                <Button color="success" type="button" onClick={aplicaProporcion}>
                  Aplicar
                </Button>
              </div>
            </ModalBody>
          </Modal>

          {/* Alta de cliente con TODOS los datos (mismo formulario que ClientesCreate) */}
          <Modal size="xl" isOpen={modalCliente} toggle={toggleCliente}>
            <ModalHeader toggle={toggleCliente}>
              <i className="fas fa-user-plus" style={{ marginRight: 8, color: "#3b82f6" }} />
              Nuevo Cliente
            </ModalHeader>
            <ModalBody>
              <ClientesCreate embebido onCreado={clienteCreado} onCancelar={toggleCliente} />
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default VentaDirecta;
